import Loading from '@/shared/components/loading/loading';
import useAuth from '@/core/services/auth/auth';
import React, { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
    const { authState, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return <Loading />;
    }
    if (!authState.isAuthenticated || !authState.user) {
        const pendingPath = `${location.pathname}${location.search}${location.hash}`;
        const encodedPath = encodeURIComponent(pendingPath || '/');
        return <Navigate to={`/login?prevLocation=${encodedPath}`} replace />;
    }
    return children;
};

export default ProtectedRoute;